module.exports = __webpack_public_path__ + "img/dashed-arrow2.b45464a.png";